
import Layout from '../../common/layouts/Layout';
import Navbar from '../../common/Navbar/Navbar';
import ECSubmissionsTable from './Table/ECSubmissionsTable';

const ECSubmissionsContainer = () => {

    return (
        <Layout>
            <>
                <Navbar pageTitle="EC Submission" />
                <ECSubmissionsTable />
            </>
        </Layout>
    )
}

export default ECSubmissionsContainer;